import { InteractionRequiredAuthError } from '@azure/msal-browser';
import type { ErrorDto } from '@portals/shared/common/ErrorDto';
import { ApiError } from '@portals/shared-frontend/utils/ApiError';

import { loginRequest, msalInstance } from './authConfig';

type Method = 'get' | 'post' | 'put' | 'patch' | 'delete';

export async function request<T>(url: string, method: Method, body?: object): Promise<T> {
  const token = await getAzureToken();

  if (!token) {
    throw new Error('Failed to fetch token');
  }

  const headers = new Headers();
  headers.set('Authorization', `Bearer ${token}`);

  const result = await fetch(`/service${url}`, {
    method: method.toUpperCase(),
    headers,
    body: JSON.stringify(body),
  });

  if (result.status > 299) {
    let body: ErrorDto;

    try {
      body = await result.json();
    } catch {
      throw new Error('Unknown error');
    }

    throw new ApiError(result.status, body);
  }

  return result.status !== 204 && result.headers.get('Content-Type') === 'application/json'
    ? result.json()
    : result.text();
}

export async function getAzureToken(): Promise<string | null> {
  const [account] = msalInstance.getAllAccounts();

  if (!account) return null;
  msalInstance.setActiveAccount(account);

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  } catch (error) {
    // Catch interaction_required errors and call interactive method to resolve
    if (error instanceof InteractionRequiredAuthError) {
      try {
        await msalInstance.acquireTokenRedirect({
          ...loginRequest,
          account,
        });
      } catch (error_) {
        // eslint-disable-next-line no-console
        console.log(error_);
      }
    } else {
      //TODO check for better ways
      localStorage.clear();
      location.reload();
    }

    return null;
  }
}
